"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = require("./helpers/confirmMarkAsPhishing");
var createItemContextsForDeleteStoreUpdate_1 = require("./helpers/createItemContextsForDeleteStoreUpdate");
var markItemsAsPhishingBasedOnItemIds_1 = require("./helpers/markItemsAsPhishingBasedOnItemIds");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var owa_mail_store_1 = require("owa-mail-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Mark item as phishing from reading pane
 * @param itemId of the item to be marked as phishing
 * @param actionSource that triggers the action
 */
exports.default = legacy_1.select({
    item: function (itemId) { return owa_mail_store_1.mailStore.items.get(itemId); },
})(function markItemsAsPhishingFromReadingPane(itemId, actionSource, state) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markItemsAsPhishingBasedOnItemIds_1.default([itemId], actionSource, function () {
            var itemContexts = createItemContextsForDeleteStoreUpdate_1.default([itemId]);
            // Dispatch action to update the store state
            deleteItemsStoreUpdate_1.default(itemContexts, state.item.ParentFolderId.Id);
        });
    });
});
//# sourceMappingURL=markItemAsPhishingFromReadingPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markItemAsPhishingFromReadingPane.js
// module id = 5615
// module chunks = 62